// Règles de mot de passe partagées par les formulaires de changement (connexion et menu admin).
// Module pur, sans dépendance, testé sous node (passwordRules.test.mjs).

// Même règle que profile-about-itemPerso : 8 caractères, un chiffre, une minuscule, une majuscule.
export const PASSWORD_RULE = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;

export const PASSWORD_RULE_MESSAGE =
	"Le mot de passe doit contenir au moins 8 caractères dont un chiffre, une minuscule et une majuscule.";

// Statut 3 (passwordReset) : mot de passe temporaire reçu par e-mail, à changer avant d'aller plus loin.
export function mustChangePassword(status) {
	return String(status) === "3";
}

// Renvoie le premier message d'erreur, ou null si la saisie est valide.
export function validateNewPassword({ current, next, confirm }) {
	if (!current) {
		return "Votre mot de passe actuel doit être renseigné.";
	}
	if (!next) {
		return "Le nouveau mot de passe doit être renseigné.";
	}
	if (!PASSWORD_RULE.test(next)) {
		return PASSWORD_RULE_MESSAGE;
	}
	if (next !== confirm) {
		return "La confirmation ne correspond pas au nouveau mot de passe.";
	}
	if (next === current) {
		return "Le nouveau mot de passe doit être différent de l'actuel.";
	}
	return null;
}
